import { render, staticRenderFns } from "./BusGisBrandPowerList.vue?vue&type=template&id=e6b85a08&scoped=true&"
import script from "./BusGisBrandPowerList.vue?vue&type=script&lang=js&"
export * from "./BusGisBrandPowerList.vue?vue&type=script&lang=js&"
import style0 from "./BusGisBrandPowerList.vue?vue&type=style&index=0&id=e6b85a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b85a08",
  null
  
)

export default component.exports